import React, { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import FormSpinner from '../../../components/FormSpinner';
import PageEvidenceScanLogin from '../../../pages/PageEvidenceScanLogin';

const EvidenceScanInOutTransferPage = lazy(() => import('../pages/EvidenceScanInOutTransferPage'));

const EvidenceScanEntryRoute = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

  if (!isAuthenticated) {
    return <PageEvidenceScanLogin />;
  }

  return (
    <Suspense fallback={<FormSpinner />}>
      <EvidenceScanInOutTransferPage />
    </Suspense>
  );
};

export default EvidenceScanEntryRoute;
